import React, { useEffect, useState } from 'react';
import { Modal, Form, Row, Col, Button } from 'react-bootstrap';

import Select from 'react-select';

import ApiServiceServerless from '../../../xhr_libs';
import SmallerLoader from '../../SmallerLoader';


export default function SolarCreateLocusModal(props) {
  const {
    show,
    onHide,
    organization,
    solarProvider,
    subAccounts,
    setSubAccounts,
    updateAccess,
    activeLicense,
    showToast,
    setSolarMeters,
  } = props;


  const [meterName, setMeterName] = useState('');
  const [meterId, setMeterId] = useState('');
  const [subAccountId, setSubAccountId] = useState('')

  const [formattedSubAccounts, setFormattedSubAccounts] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);

  const [isSaving, setIsSaving] = useState(false);


  useEffect(() => {
    setMeterName('')
    setMeterId('')
    setSubAccountId('')
  }, [show])

  useEffect(() => {
    let sub_accounts = [];

    subAccounts.forEach((sub) => {
      let local_sub_account = { ...sub };
      local_sub_account.sub_account_name_formatted = `${sub.utility_account_name} (${sub.name})`
      sub_accounts.push(local_sub_account)
    })
    setFormattedSubAccounts(sub_accounts)
  }, [subAccounts])

  useEffect(() => {
    let select_options = [{ 'value': '', 'label': '-', 'isDisabled': true }]
    formattedSubAccounts.filter(
      (sub_account) => !sub_account.solar_meter_id
    ).forEach((sub_account) => {
      select_options.push({
        'value': sub_account.id, 'label': sub_account.sub_account_name_formatted
      })
    })
    setSelectOptions(select_options)

  }, [formattedSubAccounts])

  const handleSubmit = () => {
    setIsSaving(true);
    ApiServiceServerless.post(
      `/solar/link/${subAccountId}/link`,
      { meter_id: `${meterId}`, name: meterName, solar_active: true, organization_solar_provider_id: solarProvider.id },
      {
        authorization_id: organization.id,
      }
    )
      .then((res) => {
        setSubAccounts((prev) =>
          prev.map((sub_account) => {
            if (sub_account.id !== res.data[0].id) return sub_account;
            return res.data[0];
          })
        );
        setSolarMeters((prev) => [...prev, {
          'id': meterName + `${meterId}`,
          'meter_id': `${meterId}`,
          'name': meterName,
          'status': 'active',
          'solar_provider_id': solarProvider.solar_provider_id, 'organization_solar_provider_id': solarProvider.id
        }])
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      })
      .finally(() => {
        onHide();
        setIsSaving(false);
      });
  };


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>Create Solar Meter</Modal.Header>

      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Form.Group controlId='solar.formGridId'>
              <Form.Label>Site ID  </Form.Label>
              <Form.Control
                name='meterId'
                value={meterId}
                onChange={(e) => { setMeterId(e.target.value) }}
              />
            </Form.Group>
            <Form.Group controlId='solar.formGridNumber'>
              <Form.Label>Meter Name </Form.Label>
              <Form.Control
                name='meterName'
                value={meterName}
                onChange={(e) => { setMeterName(e.target.value) }}
              />
            </Form.Group>

            <Form.Group controlId='solar.formSubAccountLink'>
              <Form.Label>Linked EnergyTracer SubAccount</Form.Label>
              <Form.Row>
                <Col>
                  <Select
                    key={subAccountId}
                    defaultValue={subAccountId && formattedSubAccounts.length > 0 ? {
                      value: subAccountId, 'label': formattedSubAccounts.find((sub) => sub.id === subAccountId).sub_account_name_formatted
                    } : { value: '', 'label': '-' }}
                    onChange={(option) => {
                      setSubAccountId(option.value);
                    }}
                    options={selectOptions}
                    classNamePrefix='et-react-select'
                  />
                </Col>
              </Form.Row>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%' }}>
          {updateAccess && activeLicense && (
            <>
              <>
                <Button
                  data-id='btn_save'
                  type='submit'
                  variant='primary'
                  className='float-right ml-3'
                  onClick={() => handleSubmit()}
                  disabled={isSaving || meterName === "" || meterId === "" || subAccountId === ""}
                >
                  {!isSaving && <>{'Submit'}</>}
                  {isSaving && <SmallerLoader text={'Submitting...'} />}
                </Button>
                <Button
                  data-id='btn_cancel'
                  type='button'
                  variant='outline-danger'
                  className='float-right'
                  onClick={() => onHide()}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
              </>
            </>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}
